export default "__VITE_ASSET__BnjdLHjR__"